import Component from "irep/modules/component";
export class VideoTracking extends Component {
    constructor(id, options) {
        super(id);
        this.options = $.extend({}, options);
        this.beginLog = false;
        this.endLog = false;
        this.middleLog = false;
        this.emittedEnding = false;
        const media_properties = ["currentTime", "duration"];
        this._video = document.getElementById(this.options.videoID);
        if (this._video.getElementsByTagName("source").length > 0) {
            this._video.addEventListener("durationchange", (e) => this.capture(e), false);
            this._video.addEventListener("timeupdate", (e) => this.capture(e), false);
        }
    }
    capture(e) {
        if ((this._video.currentTime < 5) && !this.beginLog) {
            this.logVideo(1);
            this.beginLog = true;
        }
        else if ((this._video.currentTime > (this._video.duration / 2)) && !this.middleLog) {
            this.logVideo(3);
            this.middleLog = true;
        }
        else if ((this._video.currentTime > (this._video.duration - 5)) && !this.endLog) {
            this.logVideo(2);
            this.endLog = true;
        }
        else if (this._video.currentTime > (this._video.duration - 1) && !this.emittedEnding) {
            $(this._video).trigger('video-tracking-completion', {});
            this.emittedEnding = true;
        }
    }
    logVideo(ViewType) {
        let vuid;
        if (this._video.getElementsByTagName("source")[0] != null) {
            if (this._video.getElementsByTagName("source")[0].dataset != null) {
                vuid = this._video.getElementsByTagName("source")[0].dataset.videouid;
            }
            else {
                vuid = this._video.getElementsByTagName("source")[0].getAttribute("data-videoUID");
            }
            window.irep.getHtml({
                url: '/api/education/videotracker',
                type: 'POST',
                data: {
                    VideoId: this.options.videoUID,
                    ActivityCode: vuid,
                    ViewType: ViewType,
                    Source: ""
                }
            });
        }
    }
}
export class NonEduVideoTracking {
    constructor(videoElement) {
        this.beginLog = false;
        this.middleLog = false;
        this.endLog = false;
        if ($(videoElement).parents(".education-detail7").length > 0) {
            return;
        }
        this.video = videoElement;
        this.videoURL = this.video.currentSrc;
        this.video.addEventListener('loadedmetadata', () => {
            if (this.videoURL !== this.video.currentSrc) {
                this.videoURL = this.video.currentSrc;
                [this.beginLog, this.middleLog, this.endLog] = [false, false, false];
            }
        });
        if (this.video.getElementsByTagName("source").length > 0) {
            this.video.addEventListener("durationchange", (e) => this.capture(e), false);
            this.video.addEventListener("timeupdate", (e) => this.capture(e), false);
        }
    }
    capture(e) {
        if (this.videoURL) {
            if ((this.video.currentTime < 5) && !this.beginLog) {
                this.logVideo(1);
                this.beginLog = true;
            }
            else if ((this.video.currentTime > (this.video.duration / 2)) && !this.middleLog) {
                this.logVideo(3);
                this.middleLog = true;
            }
            else if ((this.video.currentTime > (this.video.duration - 5)) && !this.endLog) {
                this.logVideo(2);
                this.endLog = true;
            }
        }
    }
    logVideo(ViewType) {
        window.irep.getHtml({
            url: 'api/videotracker',
            type: 'POST',
            data: {
                ViewType: ViewType,
                URL: this.videoURL
            }
        });
    }
}
